/**
 * Permit page hero background overrides by URL `:departmentId` only.
 * Extend `HERO_BG_BY_ROUTE_SEGMENT` when a route needs a fixed asset; otherwise CMS/static/API supplies the image.
 */
const ENVIRONMENTAL_HERO = '/images/WestVirginia/2026.03.27_One-Stop Shop Website/C.-Loomis-New-River-Gorge-LR--4-.webp';
const REVENUE_HERO = '/images/WV/revenue.webp';
const HEALTH_HERO = '/images/WV/health.webp';
const HERO_BG_BY_ROUTE_SEGMENT = {
    /** Numeric routes (product convention). */
    '2': ENVIRONMENTAL_HERO,
    '3': HEALTH_HERO,
    '4': REVENUE_HERO,
};
export function resolveDepartmentHeroBackground(ctx) {
    const seg = ctx.departmentId.trim().toLowerCase();
    const path = HERO_BG_BY_ROUTE_SEGMENT[seg];
    return path ?? null;
}
